export class SliceModel{
  constructor(
    public start = 0,
    public end = 100
  ){}
}
